import {ChangeDetectionStrategy, Component} from '@angular/core';

@Component({
  selector: 'app-fiscal-row',
  standalone: true,
  templateUrl: './fiscal-row.component.html',
  styleUrl: './fiscal-row.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FiscalRowComponent {}
